import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { BranchFollowGroupsContextImport } from "../../../../provider/branch/branch_follow_groups/BranchFollowGroupsContextProvider";
import { ButtonDouble } from "../../../../widget/common/form/Button";

const BranchFollowGroupsButtons = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const { groupList, onClikcReset, onClickSubmit } =
    BranchFollowGroupsContextImport();

  return (
    <div style={{ width: type === 3 ? 420 : `100%` }}>
      {groupList != null && (
        <ButtonDouble
          title1="reset"
          title2="submit"
          handleClick1={onClikcReset}
          handleClick2={onClickSubmit}
        />
      )}
    </div>
  );
};

export default BranchFollowGroupsButtons;
